import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import {
  ActiveRequests,
  CompletedRequests,
  CancelledRequests,
} from "./components";

function Requests(props) {
  //0 for active
  //1 for completed
  //2 for cancelled
  const [requestType, setRequestType] = useState(
    localStorage.getItem("clientReqType")
      ? localStorage.getItem("clientReqType")
      : "0"
  );
  const [counts, setCounts] = useState({
    activeCount: 0,
    doneCount: 0,
    cancelCount: 0,
  });
  useEffect(() => {
    localStorage.setItem("clientReqType", requestType);
  }, [requestType]);
  return (
    <>
      <section id="content-wrapper" className="content-wrapper calendar-page">
        <div className="container-fluid min-width-650">
          <p className="small-text-bold page-title">My requests</p>
          <div className="calendar-wrapper mt-40 mt-m-20 pb-30">
            <div className="row">
              <div className="col-12 text-left">
                <div className="status-buttons mb-3">
                  <span
                    onClick={() => setRequestType("0")}
                    className={
                      requestType === "0"
                        ? "custom-btn-small custom-button-extra-small req-status-button req-active active"
                        : "custom-btn-small custom-button-extra-small req-status-button filter-button req-active"
                    }
                  >
                    Active ({counts.activeCount})
                  </span>

                  <span
                    onClick={() => setRequestType("1")}
                    className={
                      requestType === "1"
                        ? "custom-btn-small custom-button-extra-small req-status-button filter-button req-done active"
                        : "custom-btn-small custom-button-extra-small req-status-button filter-button req-done"
                    }
                  >
                    Completed ({counts.doneCount})
                  </span>
                  <span
                    onClick={() => setRequestType("2")}
                    className={
                      requestType === "2"
                        ? "custom-btn-small custom-button-extra-small req-status-button filter-button req-cancelled  active"
                        : "custom-btn-small custom-button-extra-small req-status-button filter-button req-cancelled "
                    }
                  >
                    Cancelled ({counts.cancelCount})
                  </span>

                  <div className="clearfix"></div>
                </div>
              </div>
            </div>
            {/* // */}
            {requestType === "0" && <ActiveRequests setCounts={setCounts} />}
            {requestType === "1" && <CompletedRequests setCounts={setCounts} />}
            {requestType === "2" && <CancelledRequests setCounts={setCounts} />}
          </div>
        </div>
      </section>
    </>
  );
}

export default withRouter(Requests);
